var _defs, _ellipse, _ellipse2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatarDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 39.989,
    viewBox: "0 0 40 39.989",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f0f0f0;}.b{fill:#c7c7c7;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 20,
    cy: 19.995,
    rx: 20,
    ry: 19.995
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 5.263,
    cy: 6.235,
    rx: 5.263,
    ry: 6.235,
    transform: "translate(14.39 7.852)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-284.533,266.789s1.546-4.777,5.673-6.95a.874.874,0,0,1,.957-.045c.486.279,3.457,1.978,5.975.078a1.019,1.019,0,0,1,.882.033c.1.075,3.612,1.441,5.734,6.7a12.694,12.694,0,0,1-9.715,4.642A12.81,12.81,0,0,1-284.533,266.789Z",
    transform: "translate(294.923 -239.115)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarDefault);
export default __webpack_public_path__ + "static/media/avatar-default.fc0e71d1a37ce7485ce5fca7e467a9fb.svg";
export { ForwardRef as ReactComponent };